export default "__VITE_ASSET__BgeVQRCW__"